export const darkMode = {
  bgColor: "#353535",
  textColor: "whitesmoke",
  accentColor: "#4cd137",
};

export const lightMode = {
  bgColor: "whitesmoke",
  textColor: "#353535",
  accentColor: "#4cd137",
};
